import {createSelector} from 'reselect';

const getAllPropsSelector = (state, ownProps) => {
    return {
        user: getSelectedUser(state, ownProps),
        roles: state.roles,
        initialValues: getSelectedUser(state,ownProps)
    };
};

function getSelectedUser(state, ownProps) {
    if (ownProps.routeParams.user) {
        const user = state.users.filter((user) => user.id == ownProps.routeParams.user);
        if(user.length==1) return user[0];
    }
    return null;
}

export default getAllPropsSelector;


/** WEBPACK FOOTER **
 ** ./src/form/UserForm/selectors.js
 **/